import { ChainId } from '@/lib/chain'
import { TEnvConfig } from './env.interfact'
import { PROD_CONFIG } from './prod'

export const DEV_CONFIG: TEnvConfig = {
  ...PROD_CONFIG,
  amplitudeApiKey: '5fc3dae2d16504b413bd010d4978e8ae',
  supportedChains: [
    ChainId.ETHEREUM,
    ChainId.OPTIMISM,
    ChainId.BSC,
    ChainId.BASE,
    ChainId.ARBITRUM
  ],
  defaultChainId: ChainId.OPTIMISM,
  kulapPlusApiBaseUrl: 'https://dev-plus-api.kulap.io/api/v1',
  kulapPlusUtilityFileUrl:
    'https://kulap-plus-utility-file-dev.s3.ap-southeast-1.amazonaws.com',
  kulapPlusTokenListFilePath: {
    [ChainId.ETHEREUM]: '/token-lists/ethereum.json',
    [ChainId.OPTIMISM]: '/token-lists/optimism.json',
    [ChainId.BSC]: '/token-lists/bsc.json',
    [ChainId.BASE]: '/token-lists/base.json',
    [ChainId.ARBITRUM]: '/token-lists/arbitrum.json'
  },
  kulapSwapFrontendUrl: 'http://alpha.kulap.io',
  kulapPlusFrontendUrl: 'https://dev-app.kulap.io',
  googleRecaptcha: '6Ld_pMUZAAAAAM5Pajn7kxKwQRbJGoqIRb3axu7Y',
  facebookAppId: '2228084830653503',
  initFromFiatCurrencyAmount: '17',
  checkUserEligibilityTrade: true,
  depositSwapContractAddresses: {
    [ChainId.ETHEREUM]: '0x2991c6fc3250378B1BD4EdDa4D59428aE74De85F',
    [ChainId.BSC]: '0xa914b8009378896c9D8f111f299aC9414e1135a7',
    [ChainId.OPTIMISM]: '0x2a4f1648EF6a78AC5F9C82FDb1D729a2813B5d8a',
    [ChainId.BASE]: '0xe218C71ca5cc7eDB90461291D73046D7BA29fA3E',
    [ChainId.ARBITRUM]: '0xF8d89Fb9ca5f66Ba56779780DC13f81558fDF843'
  },
  // ? ThaiD type production
  // thaiD: {
  //   apiEndpoint: 'https://imauth.bora.dopa.go.th/api/v2',
  //   clientId: 'VGFFMzN2QXFTd2o4WUZUN3B4RlFjSU9ud3V2bUtvY0k',
  //   redirectUri:
  //     'https://dev-plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  // }
  // ? ThaiD type [sandbox]
  thaiD: {
    apiEndpoint: 'https://imauthsbx.bora.dopa.go.th/api/v2',
    clientId: 'bXpYVEJsNmV4NUNLdTkxNVRDaXd1MTJJM3VlNFlVVGg',
    redirectUri:
      'https://dev-plus-api.kulap.io/api/v1/kyc-provider/thaid/callback'
  }
}
